
<ng-container *ngIf='loaded$|async as loaded; else loadingContent'>
  <app-main-content style="font-family: Sora ;width: 100%;" [title]='nombreInstitucion$|async'>
    <div class="flex flex-1 min-h-screen dark:bg-black-shade-300">
      <div class="flex flex-1 flex-col">
        <div class="flex flex-none top-0 z-50">
          <app-header></app-header>
        </div>
        <div style="width: 100%;height: 100%">
          <router-outlet></router-outlet>
        </div>
        <div class="flex flex-none">
          <app-footer></app-footer>
        </div>
        <ng-container *ngIf="footer$|async as footer;">
          <button title="Contact Sale" (click)="goWhatsapp(footer.whatsapp)"
            class="wsp-btn fixed z-90 bg-green-400 hover:bg-green-200 rounded-full drop-shadow-xl
            flex justify-center items-center text-white text-4xl">
            <fa-icon [icon]="faWhatsapp"></fa-icon>
          </button>
        </ng-container>
      </div>
    </div>
  </app-main-content>
</ng-container>

<ng-template #loadingContent>
  <app-loader></app-loader>
</ng-template>